<app-base-edit-form-modal
  [fields]="fields"
  [parentId]="purchaseOrderLineId"
  [baseService]="purchaseOrderLineRequirementService"
  (saved)="saved()"
>
</app-base-edit-form-modal>
